/*
 * Pathway D in-editor save-prompt predicate (Cluster 5 Slice 2 / A8 pt 6, R4).
 *
 * Pure scan of the in-memory workflow definition nodes. The prompt fires iff:
 *   - the workflow's pathway_d_enabled === false, AND
 *   - the workflow has NO action_extract node, AND
 *   - the workflow has NO match-capable action_classify node
 *     (R-classify: method === 'template_match').
 *
 * An ai_primary action_extract COUNTS as a capable path — it is still an
 * action_extract node, so hasMatchCapablePath is true and the prompt does NOT
 * fire (per the ruling). In practice the prompt is an edge-case guard: it only
 * fires for a workflow that has no extraction step at all while Pathway D is off.
 */
export function pathwayDPromptShouldFire(workflow, nodes) {
  if (!workflow || workflow.pathway_d_enabled !== false) return false;
  const hasMatchCapablePath = (nodes || []).some(
    (n) =>
      n?.type === 'action_extract' ||
      (n?.type === 'action_classify' && n?.data?.config?.method === 'template_match'),
  );
  return !hasMatchCapablePath;
}
